<template>
  <ItemDialog ref="dialogRef" image-type="done">
    <template #content-area>
      <h2>予約取り消しが完了しました</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogCompleteReservationCancel",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
      nativeHandlerService.returnNativeDbsIndexPage();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
